

































































































import { Component, Vue } from "vue-property-decorator";
import _ from "lodash";
import loading from "@/components/loader/loading.vue";
import {
  CountCompanyDocumentResponse,
  DepartmentDocumentResponse,
  DocumentResponse,
  NotifyOnEmployeeDocument,
} from "@/api";
import UploadDoc from "@/components/EmployeeDocument/UploadDoc.vue";
import MobileUploadDoc from "@/components/EmployeeDocument/MobileUploadDoc.vue";
import CamAccess from "@/components/camAccess/CamAccess.vue";
import ConfirmModal from "@/components/EmployeeDocument/ConfirmModal.vue";
import { checkSelfRole, isSuperAdmin, selfData } from "@/common/role_utils";

@Component({
  components: {
    loading,
    UploadDoc,
    CamAccess,
    MobileUploadDoc,
    ConfirmModal,
  },
})
export default class DocumentMenu extends Vue {
  isDataLoading = false;
  uploadDialog = false;
  uploadKey = 0;
  adDocumentId = -1;
  adDocumentName = "";
  camDialog = false;
  camKey = 0;
  uploadConfirm = false;
  text =
    "Your document is successfully uploaded. Please wait for the verification from the supervisor.";

  get isSuperAdmin(): boolean {
    return isSuperAdmin();
  }

  get isOwner(): boolean {
    return checkSelfRole("owner") || this.isSuperAdmin;
  }

  get isAdmin(): boolean {
    return checkSelfRole("admin") || this.isSuperAdmin;
  }

  get self() {
    return selfData();
  }

  async created() {
    this.isDataLoading = true;
    try {
      if (this.isOwner) {
        await this.$store.dispatch("departmentAdmin/getDocuments");
        if (this.self?.primaryDepartmentId) {
          await this.$store.dispatch(
            "departmentAdmin/getDepartmentDocuments",
            this.self.primaryDepartmentId,
          );
        }
      } else {
        if (this.self?.primaryDepartmentId) {
          await this.$store.dispatch(
            "departmentAdmin/getDepartmentDocuments",
            this.self.primaryDepartmentId,
          );
        }
      }
      await this.$store.dispatch(
        "employeeDocuments/getDocumentNotificationByDepartmentDocument",
        false,
      );
    } catch (e) {
      console.error(e);
    } finally {
      this.isDataLoading = false;
    }

    if (
      !this.$route.params?.documentId &&
      this.documents?.length &&
      !this.$vuetify.breakpoint.smAndDown
    ) {
      const firstDoc = this.documents[0];
      this.selectDocument(
        firstDoc.id,
        firstDoc.document_id,
        firstDoc.name || firstDoc.document_name,
      );
    }
  }

  isActive(id: number, documentId: number) {
    const docId = documentId ? (this.isAdmin ? documentId : id) : id;
    return docId.toString() === this.$route.params?.documentId;
  }

  isRole(role: string) {
    if (this.isSuperAdmin) return true;
    return checkSelfRole(role.toLowerCase());
  }

  get documents() {
    let documentList;
    const countList = this.$store.getters[
      "employeeDocuments/companyDocumentCount"
    ];
    const notifications = this.$store.getters[
      "employeeDocuments/documentNotificationByDepartmentDocument"
    ];
    if (this.isOwner) {
      documentList = this.$store.getters["departmentAdmin/documents"];
      const listWithCount = documentList?.map((document: DocumentResponse) => {
        const foundItem = countList?.find(
          (count: CountCompanyDocumentResponse) =>
            count.document_id === document.id,
        );
        const countNotification = notifications?.find(
          (notification: NotifyOnEmployeeDocument) =>
            notification.document_id === document.id,
        );
        return {
          ...document,
          count: foundItem?.count || 0,
          notification: countNotification?.notify_flag || 0,
        };
      });
      documentList = listWithCount;
    } else {
      documentList = this.$store.getters["departmentAdmin/departmentDocuments"];
      const listWithCount = documentList?.map(
        (document: DepartmentDocumentResponse) => {
          const foundItem = countList?.find(
            (count: CountCompanyDocumentResponse) =>
              count.document_id === document.document_id,
          );
          const countNotification = notifications?.find(
            (notification: NotifyOnEmployeeDocument) =>
              notification.document_id === document.document_id,
          );
          return {
            ...document,
            count: foundItem?.count || 0,
            uploadFlag: foundItem?.upload_flag || 0,
            notification: countNotification?.notify_flag || 0,
          };
        },
      );
      documentList = listWithCount;
    }

    return _.orderBy(
      documentList,
      document => document.name || document.document_name,
    );
  }

  selectDocument(id: number, documentId: number, title: string) {
    const docId = documentId ? (this.isAdmin ? documentId : id) : id;
    this.$router.push({ path: `/company-document/${docId}`, query: { title } });
  }

  addDocument(documentId: number, documentName: string) {
    this.uploadKey++;
    this.adDocumentId = documentId;
    this.adDocumentName = documentName;
    this.uploadDialog = !this.uploadDialog;
  }

  takePic(documentId: number, documentName: string) {
    this.adDocumentId = documentId;
    this.adDocumentName = documentName;
    this.camKey++;
    this.camDialog = !this.camDialog;
  }

  closeUpload(upload: boolean) {
    this.uploadKey++;
    this.uploadDialog = false;
    this.uploadConfirm = upload;
  }

  closeConfirm() {
    this.uploadConfirm = false;
    if (this.$vuetify.breakpoint.smAndDown)
      this.$router.push("/company-document/" + this.adDocumentId);
  }

  getIcon(flag: number) {
    if (flag == 0) return "";
    else if (flag == 1 || flag == 2) return "mdi-alert-outline";
    else return "mdi-alert-circle";
  }

  getColor(flag: number) {
    if (flag == 0) return "";
    else if (flag == 1 || flag == 2) return "yellow";
    else return "red";
  }
}
